import { ResourceMediaStatusIds } from '@actschurch/ccms-sdk';
import type { ResourceMediaView } from '@actschurch/ccms-sdk';

export interface TranscriptSource {
  /** 'ready' when a transcript URL exists; 'pending' when media is linked but no transcript yet. */
  status: 'ready' | 'pending';
  vttUrl?: string | null;
  txtUrl?: string | null;
  language?: string | null;
}

/**
 * What a transcript surface should show for a session or step, or null to
 * hide it:
 *  - 'ready' when the media has captions or a plain-text transcript.
 *  - 'pending' when media is linked and still on its way ("Transcript not
 *    available yet").
 *  - null when transcripts are switched off, nothing is linked, or the media
 *    failed or does not apply.
 */
export function transcriptSourceFor(
  media: ResourceMediaView | null | undefined,
  transcriptsOff: boolean,
): TranscriptSource | null {
  if (!media || transcriptsOff) return null;
  if (media.captionsVttUrl || media.transcriptTxtUrl) {
    return {
      status: 'ready',
      vttUrl: media.captionsVttUrl ?? null,
      txtUrl: media.transcriptTxtUrl ?? null,
      language: media.transcriptLanguage ?? null,
    };
  }
  const status = media.mediaStatusID;
  if (
    media.mediaFileId &&
    status !== ResourceMediaStatusIds.Failed &&
    status !== ResourceMediaStatusIds.NotApplicable
  ) {
    return { status: 'pending' };
  }
  return null;
}
